import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import { store } from 'redux/store';
import styles from 'layouts/RootLayout.module.scss';

const cn = classNames.bind(styles);

const Header = dynamic(() => import('components/Header'));
const Footer = dynamic(() => import('components/Footer'));

interface RootLayoutProps {
  children: ReactNode;
  withFooter?: boolean;
};

export default function RootLayout({ children, withFooter = true }: RootLayoutProps) {
  return (
    <Provider store={store}>
      <div className={cn('app')}>
        <Header />

        <main className={cn('app__main')}>{children}</main>

        {withFooter && <Footer />}
      </div>
    </Provider>
  );

  // return (
  //   <Provider store={store}>
  //     <div className="app">
  //       <Header />

  //       <main className="app__main">{children}</main>

  //       {withFooter && <Footer />}
  //     </div>
  //   </Provider>
  // );
}
